import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import moment from "moment";
import {PhoneNumberFormat, PhoneNumberUtil} from "google-libphonenumber";
import { PermissionsService } from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-edit-recipient',
  templateUrl: './edit-recipient.component.pug',
  styleUrls: ['./edit-recipient.component.scss'],
  standalone: false
})
export class EditRecipientComponent implements OnInit {
  @Input() recipientToEdit: any;
  @Output() closeEditEvent = new EventEmitter();
  @Output() updatedRecipient = new EventEmitter();
  recipientRow = {};
  closeComponent = false;
  recipientLastName!: string;
  endDateMonth = 0;
  END_DATE_MONTHS: any[] = [];
  listOfYears: number[] = [];
  disableSend = true;
  phoneUtil = PhoneNumberUtil.getInstance();

  constructor( private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.END_DATE_MONTHS = moment.months();
    this.recipientRow = {...this.recipientToEdit['recipient']};
    this.endDateMonth = this.END_DATE_MONTHS.indexOf(this.recipientRow['end_date_month']) + 1;
    let currentYear = Number(moment().format('yyyy'))
    for (let i = currentYear; i >= 1970; i--) {
      this.listOfYears.push(i)
    }
    this.disableCheck();
  }

  closeEdit() {
    this.closeComponent = true;
    this.closeEditEvent.emit(this.closeComponent);
  }

  disableCheck() {
    if (this.recipientRow['first_name'].trim() && this.recipientRow['last_name'].trim() && this.endDateMonth !== -1 && this.recipientRow['end_date_year'] && (this.recipientRow['email'] || this.recipientRow['mobile_phone'])) {
      this.disableSend = false;
    } else this.disableSend = true;
  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return 'none';
  }

  checkDate(recipient) {
    if (recipient.end_date_month === "" && recipient.end_date_year !== "") {
      recipient['date'] = recipient.end_date_year;
      return 'error';
    }
    if (recipient.end_date_year === "" && recipient.end_date_month !== "") {
      recipient['date'] = recipient.end_date_month;
      return 'error';
    }
    if (recipient.end_date_year === "" && recipient.end_date_month === "") {
      recipient['date'] = "";
      return 'error';
    }
    recipient['date'] = recipient.end_date_month + ', ' + recipient.end_date_year
    if (isNaN(recipient['end_date_year'])) {
      return 'error';
    }
    return 'none';
  }

  saveDetails(recipient) {
    recipient['end_date_month'] = this.endDateMonth;

    if (recipient['mobile_phone'] === "null" || !recipient['mobile_phone']) {
      recipient['mobile_phone'] = ''
      recipient['country_code'] = ''
    }
    let payloadToEdit = {
      "recipient": recipient,
    }

    if (recipient['first_name'] && recipient['last_name'] && recipient['end_date_month'] !== -1 && recipient['end_date_year'] !== -1 && (this.recipientRow['email'] || this.recipientRow['mobile_phone'])) {
      this.disableSend = false;
      this.updatedRecipient.emit(payloadToEdit);
      this.closeEdit();
    }
  }

  phoneUpdate(event) {
    this.recipientRow['country_code'] = event['country_code'];
    this.recipientRow['mobile_phone'] = event['mobile_phone'];
    let phone = event['country_code'] + event['mobile_phone'];
    let parsedPhone = '';
    try {
      parsedPhone = this.phoneUtil.parseAndKeepRawInput(phone);
      this.recipientRow['mobile'] = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
    } catch (e) {
      // needs to be handled in a better way
      console.log("Phone number parsing error: ", e);
    }
    this.disableCheck();
  }

}
